import React from 'react';
import { getBrand } from '../config/brand.js';
import LandingContentInterviewFlow from './landing/LandingContentInterviewFlow';
import LandingContentBaiglabs from './landing/LandingContentBaiglabs';

function LandingPage() {
  if (getBrand() === 'interviewflow') {
    return <LandingContentInterviewFlow />;
  }
  return <LandingContentBaiglabs />;
}

export default LandingPage;
